import cx from "classnames";
/* eslint-disable react/no-unescaped-entities */
import React, { useState } from "react";

import { BasicButton } from "@gaming/xds-react-js";

import * as commonStyles from "../../../components/commonStyles/commonStyles.module.css";
import { StreamingEuStep, StreamingEuStepDefaultProps } from "../models";
import {
  StreamingButtonLabels,
  StreamingEuStepTitle,
  UserEntitlementAccessNo,
  UserEntitlementAccessYes,
  UserEntitlementDataSubtitle,
} from "../streamingEuContent";
import * as styles from "../StreamingEuPage.module.css";
import { StreamingEuCloseButton } from "./StreamingEuCloseButton";

export const UserEntitlementData = ({
  navigateToStep,
  storeStreamingData,
}: StreamingEuStepDefaultProps) => {
  const [decision, setDecision] = useState(true);
  const navigateForward = () => {
    storeStreamingData({ accessToEntitlementData: decision });
    navigateToStep(
      decision
        ? StreamingEuStep.ProviderInformationMandatory
        : StreamingEuStep.ProviderInformationOptional
    );
  };

  return (
    <>
      <h1 className={styles.title}>{StreamingEuStepTitle.UserEntitlementData}</h1>
      <div>
        <span>{UserEntitlementDataSubtitle}</span>
        <table>
          <tbody>
            <tr className={styles.verticalCentering}>
              <td>
                <input
                  type="radio"
                  name="site_name"
                  value="true"
                  checked={decision}
                  onChange={() => setDecision(true)}
                  className={styles.inputSpace}
                  aria-label={UserEntitlementAccessYes}
                />
                {UserEntitlementAccessYes}
              </td>
              <td>
                <input
                  type="radio"
                  name="address"
                  value="false"
                  checked={!decision}
                  onChange={() => setDecision(false)}
                  className={styles.inputSpace}
                  aria-label={UserEntitlementAccessNo}
                />
                {UserEntitlementAccessNo}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles.horizontalCentering}>
        <BasicButton
          as={"button"}
          onClick={navigateForward}
          className={cx(commonStyles.primaryButton, styles.buttonPadding)}
          textDecorationUnderline={true}
        >
          {StreamingButtonLabels.SubmitAndContinue}
        </BasicButton>
        <StreamingEuCloseButton />
      </div>
    </>
  );
};
